<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row" v-if="$acl.isSuperAdmin || $acl.can('create', 'users')">
            <div class="col-12">
              <div class="alert alert-primary" role="alert">نوع کاربر</div>
            </div>
            <bita-select
              name="model"
              label="نوع موجودیت"
              ref="modelDropDown"
              rules=""
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              :data-source="userTypes"
              data-text-field="name"
              data-value-field="value"
              v-model="dataForm.model_type"
              @change="(e) => onModelChange(e)"
            />
            <bita-select
              name="modelID"
              label="موجودیت"
              ref="modelIDDropDown"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              :data-source="entities"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.model_id"
            />
          </div>
          <div class="row">
            <div class="col-12">
              <div class="alert alert-primary" role="alert">اطلاعات شخصی</div>
            </div>
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
            />
            <bita-input
              type="text"
              name="username"
              label="نام کاربری"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.username"
            />
            <bita-input
              type="number"
              name="national_code"
              label="کدملی"
              rules="required|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره تماس"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
            />
            <bita-input
              v-if="!propsData.id"
              type="password"
              name="password"
              label="رمزعبور"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.password"
            />
            <bita-input
              type="postal_code"
              name="postal_code"
              label="کد پستی"
              rules="digits:10"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.postal_code"
            />
            <!-- <bita-multiselect
              name="users"
              label="کاربران"
              ref="usersMultiSelect"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="propsUsers"
              data-text-field="full_name"
              data-value-field="id"
              v-model="dataForm.user_ids"
            /> -->
            <bita-textarea
              name="address"
              class="col-12"
              inputClass="col-12 form-control"
              label="آدرس"
              v-model="dataForm.address"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div
      slot="footer"
      class="d-flex flex-column flex-md-row justify-content-between"
    >
      <div class="col-12 col-md-2 mb-2" v-if="!propsData.id">
        <bita-bootbutton
          type="primary"
          title="ذخیره"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-12 col-md-2" v-if="propsData.id">
        <bita-bootbutton
          type="primary"
          title="بروزرسانی"
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-12 col-md-2">
        <bita-bootbutton
          class="w-100 bg-transparent text-danger border-0"
          type="danger"
          title="بستن"
          icon="fas fa-times"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsUsers: {},
    entities: {
      type: Array,
    },
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        national_code: "",
        phone: "",
        postal_code: "",
        address: "",
        password: "",
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {},
      userTypes: [
        { value: "Bar\\Model\\Owner", name: "صاحب بار" },
        { value: "Bar\\Model\\Carrier", name: "باربری" },
        // { value: "Bar\\Model\\Driver", name: "راننده" },
      ],
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    onCloseModal(e) {
      this.reset();
    },
    onModelChange(e) {
      // this.$refs.modelIDDropDown.emptyKendo()
      this.$emit("change-model-type", e);
    },
  },
};
</script>
